function formatFinalSaleCartText() {
    const metaBlocks = document.querySelectorAll('.unicart__product-meta[data-type="properties"]');
  
    metaBlocks.forEach((block) => {
        const nameEl = block.querySelector('.unicart-key-name');
        const valueEl = block.querySelector('.unicart-key-value');
      
        if (nameEl && valueEl && nameEl.textContent.trim() === "Final Sale:") {
          // Update name styling
          nameEl.textContent = "FINAL SALE";
          nameEl.style.color = "#E85234";
          nameEl.style.fontWeight = "bold";
          nameEl.style.textTransform = "uppercase";
          nameEl.style.fontStyle = "normal";
          nameEl.style.opacity = "1";
      
          // Ensure the parent opacity is also set to 1
          const parentEl = nameEl.closest('.unicart-meta-info');
          if (parentEl) {
            parentEl.style.opacity = "1";
          }
      
          // Hide the value visually (optional)
          valueEl.style.display = "none";
        }
      });
      
  }
  
  formatFinalSaleCartText();
  
  // Watch for cart updates (Unicart is dynamic)
  const observer = new MutationObserver(() => formatFinalSaleCartText());
  observer.observe(document.body, { childList: true, subtree: true });
  